import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { UnloadGuard } from 'src/app/core/guards/unload.guard';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UserListComponent } from './user-list/user-list.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { AdminUserPermissionConfiguratorComponent } from '../admin-user-permission-configurator/admin-user-permission-configurator.component';

const routes: Routes = [
  {
    path: 'users',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: UserListComponent },
      { path: 'new/:subTenantId', component: UserDetailComponent, canDeactivate: [UnloadGuard] },
      {
        path: 'rights-configurator/:userId',
        component: AdminUserPermissionConfiguratorComponent,
        canDeactivate: [UnloadGuard],
      },
      { path: ':subTenantId/:userId', component: UserDetailComponent, canDeactivate: [UnloadGuard] },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class UsersRoutingModule {}
